import { Component, Input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { isDebugMode } from '@vmspdb/ui/store';

@Component({
  selector: 'vmspdb-ui-debug',
  templateUrl: './debug.component.html',
  styleUrls: ['./debug.component.scss'],
  standalone: false,
})
export class DebugComponent {
  private store = inject(Store);

  @Input()
  model: any = {};

  @Input()
  name = 'form';

  debugging$ = this.store.select(isDebugMode);

  toJson(model: unknown): string {
    return JSON.stringify(
      model,
      (_key, value) => (typeof value === 'bigint' ? value.toString() : value),
      2,
    );
  }
}
